<template>
    <div class="bodyx">
        <v-row>
            <v-col cols="12" class="mt-5">
                <h1>ACACIA LOTTO</h1>
            </v-col>
        </v-row>
        <!-- class="position floatfix" -->
        <v-row>
            <v-col cols="12" align="center">
                <div class="history2">
                    <h2>emp id</h2>
                    xx
                </div>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                :align="isMobile == true ? 'center' : 'right'"
            >
                <div class="history">
                    <h2>xxxx</h2>
                    <p>xxx</p>
                </div>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                :align="isMobile == true ? 'center' : 'left'"
            >
                <div class="wrapper">
                    <h2>#1</h2>
                    <p
                        :class="chk_ball('a', 1) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 1)"
                    >
                        1
                    </p>
                    <p
                        :class="chk_ball('a', 2) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 2)"
                    >
                        2
                    </p>
                    <p
                        :class="chk_ball('a', 3) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 3)"
                    >
                        3
                    </p>
                    <p
                        :class="chk_ball('a', 4) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 4)"
                    >
                        4
                    </p>
                    <p
                        :class="chk_ball('a', 5) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 5)"
                    >
                        5
                    </p>
                    <p
                        :class="chk_ball('a', 6) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('a', 6)"
                    >
                        6
                    </p>

                    <div v-if="data_lotto.set1.length">
                        <p
                            class="ball2"
                            v-for="r1 in data_lotto.set1"
                            :key="r1"
                            @click="click_ball('a', r1)"
                        >
                            {{ r1 }}
                        </p>
                    </div>
                </div>

                <div class="wrapper mt-5">
                    <h2>#2</h2>
                    <p
                        :class="chk_ball('b', 1) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 1)"
                    >
                        1
                    </p>
                    <p
                        :class="chk_ball('b', 2) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 2)"
                    >
                        2
                    </p>
                    <p
                        :class="chk_ball('b', 3) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 3)"
                    >
                        3
                    </p>
                    <p
                        :class="chk_ball('b', 4) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 4)"
                    >
                        4
                    </p>
                    <p
                        :class="chk_ball('b', 5) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 5)"
                    >
                        5
                    </p>
                    <p
                        :class="chk_ball('b', 6) == 'Y' ? 'ball3' : 'ball'"
                        @click="click_ball('b', 6)"
                    >
                        6
                    </p>

                    <div v-if="data_lotto.set2.length">
                        <p
                            class="ball2"
                            v-for="r2 in data_lotto.set2"
                            :key="r2"
                            @click="click_ball('b', r2)"
                        >
                            {{ r2 }}
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" class="mar-t-30">
                <button type="button" id="generate" class="clearfix">
                    Buy Lotto
                </button>
            </v-col>
        </v-row>
        <div>
            <link
                href="https://fonts.googleapis.com/css?family=Chewy"
                rel="stylesheet"
                type="text/css"
            />
            <link
                href="https://fonts.googleapis.com/css?family=Open+Sans"
                rel="stylesheet"
                type="text/css"
            />
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        isMobile: false,
        data_lotto: {
            set1: [],
            set2: [],
        },
    }),
    beforeDestroy() {
        if (typeof window === "undefined") return
        window.removeEventListener("resize", this.onResize, { passive: true })
    },
    mounted() {
        this.onResize()
        window.addEventListener("resize", this.onResize, { passive: true })
    },
    methods: {
        onResize() {
            this.isMobile = window.innerWidth < 600
        },
        click_ball(aa, bb) {
            if (aa == "a") {
                const found = this.data_lotto.set1.find((elem) => elem === bb)
                if (found == undefined) {
                    this.data_lotto.set1.push(bb)
                } else {
                    const filteredItems = this.data_lotto.set1.filter(
                        (item) => item !== bb
                    )
                    this.data_lotto.set1 = filteredItems
                }
            } else if (aa == "b") {
                const found2 = this.data_lotto.set2.find((elem) => elem === bb)
                if (found2 == undefined) {
                    this.data_lotto.set2.push(bb)
                } else {
                    const filteredItems2 = this.data_lotto.set2.filter(
                        (item) => item !== bb
                    )
                    this.data_lotto.set2 = filteredItems2
                }
            }
        },
        chk_ball(aa, bb) {
            if (aa == "a") {
                const found = this.data_lotto.set1.find((elem) => elem === bb)
                if (found == undefined) {
                    return "N"
                } else {
                    return "Y"
                }
            }
            if (aa == "b") {
                const found2 = this.data_lotto.set2.find((elem) => elem === bb)
                if (found2 == undefined) {
                    return "N"
                } else {
                    return "Y"
                }
            }
        },
    },
}
</script>
<style scoped>
.bodyx {
    margin: 0;
    padding: 0;
    font-family: "Open Sans", sans-serif;
    background-color: #3f2860;
}

.clearfix {
    clear: both;
}

.floatfix:after {
    display: block;
    content: "";
    clear: both;
}

h1 {
    text-align: center;
    color: #ef6d3b;
    text-shadow: 1px 1px 1px #000;
    font-family: "Chewy";
    font-size: 50px;
}

h2 {
    text-align: center;
    color: #6a00ff;
    text-shadow: 1px 1px 1px #ef6d3b;
    font-family: "Chewy";
    font-size: 35px;
}

.position {
    width: 1070px;
    margin: 0 auto;
}

.wrapper {
    width: 420px;
    background-color: #90c5a9;
    overflow: hidden;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
    /* float: left;
    margin-left: 50px; */
}

.wrapper .ball {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #3d3c3a;
    border-radius: 100%;
    float: left;
    background-color: #fff;
    margin: 10px;
    font-weight: 500;
    box-shadow: 1px 1px 0.5px #000;
    cursor: pointer;
}

.ball2 {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    border-radius: 100%;
    float: left;
    background-color: #ef6d3b;
    margin: 10px;
    font-weight: 500;
    box-shadow: 1px 1px 0.5px rgb(255, 76, 5);
    cursor: pointer;
}

.ball3 {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #682121;
    border-radius: 100%;
    float: left;
    background-color: #ac9c9c;
    margin: 10px;
    font-weight: 500;
    box-shadow: 1px 1px 0.5px rgb(36, 33, 32);
    cursor: pointer;
}

#generate {
    display: block;
    background-color: #ef6d3b;
    outline: none;
    padding: 15px;
    border-radius: 10px;
    font-size: 20px;
    margin: 50px auto;
    width: 120px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.5);
    text-transform: uppercase;
    font-family: "Chewy";
    color: #3f2860;
}

#generate:hover {
    display: block;
    background-color: #139e54;
    outline: none;
    padding: 15px;
    border-radius: 10px;
    font-size: 20px;
    margin: 50px auto;
    width: 120px;
    box-shadow: 1px 1px 0.5px rgb(255, 76, 5);
    text-transform: uppercase;
    font-family: "Chewy";
    color: #3f2860;
}

.history {
    text-align: center;
    width: 420px;
    height: 420px;
    padding: 20px 0;
    border-radius: 20px;
    background-color: #90c5a9;
    /* float: left; */
    /* margin-left: 50px; */
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
    overflow: auto;
}

.history2 {
    text-align: center;
    width: 420px;
    height: 120px;
    padding: 20px 0;
    border-radius: 20px;
    background-color: #90c5a9;
    /* float: left; */
    /* margin-left: 50px; */
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
    overflow: auto;
}

.history p {
    font-weight: 500;
    color: #3d3c3a;
}

/* // css test // */
</style>
